<template>
    <div class="sa-list-component">
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rowsMagazzinoListini }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rowsMagazzinoListini" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header :busy="isBusy" stacked="lg" striped hover :items="magazzinoListiniData" :fields="magazzinoListiniFields" sort-icon-left head-variant="light" class="sa-b-table" :selectable="selectable" select-mode="single" @row-selected="onRowSelectedArticoliItems" current-page="1" :per-page="perPage">
                    <template #cell(index)="row">
                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-container class="bv-example-row">
                            <b-button size="sm" v-b-tooltip.hover title="Visualizza Listino" variant="outline-secondary" class="mr-1 no-text" @click="onClickViewLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Modifica Listino" variant="outline-success" @click="onClickModificaLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Rimuovi Listino" variant="outline-danger" @click="onClickRimuoviLsitinoMagazzino(row.item)">
                                <font-awesome-icon icon="trash" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
                <magazzino-listini-edit-modal-component ref="cmpMagazzinoListiniEditModal" @afterSave="onAfterSave"></magazzino-listini-edit-modal-component>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rowsMagazzinoListini }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rowsMagazzinoListini" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import MagazzinoListiniMixins from "../mixins/MagazzinoListiniMixins";
import MagazzinoListiniEditModalComponent from "./MagazzinoListiniEditModalComponent.vue";
export default {
    mixins: [MagazzinoListiniMixins],
    components: { MagazzinoListiniEditModalComponent },

    data() {
        return { pathResource: "/magazzinolistini", rows: 0, perPage: 50 };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        onRowSelectedArticoliItems() {},
        onClickModificaLsitinoMagazzino(item) {
            this.$refs.cmpMagazzinoListiniEditModal.show(item.id);
        },
        onClickRimuoviLsitinoMagazzino(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Listino",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.rimuoviLsitinoMagazzino(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        rimuoviLsitinoMagazzino(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((Response) => {
                    console.log(Response);
                    me.showModalLoading = false;
                    me.loadDataMagazzinoListini();
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        onAfterSave() {
            this.loadDataMagazzinoListini();
        },
        nuovoMagazzinoListino() {
            this.$refs.cmpMagazzinoListiniEditModal.show();
        },
    },
};
</script>

<style></style>
